"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function TestCompiler() {
    console.log("If this message succeeds typescript is working");
}
exports.TestCompiler = TestCompiler;
